<template>
  <div class="landing-container relative z-[1]">
    <TopHeader class="landing-container-top" />
    <!-- <Page class="page-enter" name="enter"> -->
    <Banner />
    <GsapScrollImg />
    <AvatarFeature />
    <PersonalizedEdit />
    <StudioLibrary class="page-scene__library" />
    <Operation @handle-trial="handleTrail" />
    <Faq />
    <StartRightNow :handler="handleTrail" />
    <AppFooter />
  </div>
</template>

<script lang="ts" setup>
import AppFooter from '~/design/widgets/bottom-footer/footer-cn.vue';
import Operation from '~/design/widgets/product-operation/cn-operation.vue';
import StartRightNow from '~/design/widgets/start-right-now/index.vue';
import TopHeader from '~/design/widgets/top-header/index.vue';
import AvatarFeature from './modules/avatar-feature/index.vue';
import Banner from './modules/banner/index.vue';
import Faq from './modules/faq/index.vue';
import PersonalizedEdit from './modules/personalized-edit/index.vue';
import StudioLibrary from './modules/studio-library/index.vue';
import GsapScrollImg from './modules/swiper-imgs/gsap-scroll-img.vue';

const handleTrail = () => {
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/workspace`))}`,
    );
  } else {
    location.href = '/workspace';
  }
};
</script>

<style lang="scss" scoped>
.page-scene__library {
  border-top: 1px solid var(--x-back-4);
}
</style>
